import React from 'react';
import { typography, palette } from '../../../../utils/designTokens';

/**
 * TabNavigation - Reusable tab bar component
 * Used by all span kinds to provide consistent tab switching UI
 *
 * @param {Array<{id: string, label: string}>} tabs - Array of tab definitions
 * @param {string} activeTab - Currently active tab ID
 * @param {Function} onTabChange - Callback when tab is clicked: (tabId) => void
 */
const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  if (!Array.isArray(tabs)) {
    throw new Error('TabNavigation requires tabs prop as array');
  }
  if (!activeTab) {
    throw new Error('TabNavigation requires activeTab prop');
  }
  if (typeof onTabChange !== 'function') {
    throw new Error('TabNavigation requires onTabChange prop as function');
  }

  return (
    <div className="flex gap-2 mb-4">
      {tabs.map(tab => {
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`px-2.5 py-1 rounded-full text-sm font-medium transition-colors ${
              isActive
                ? 'bg-accent-primary-base text-text-inverse'
                : 'bg-background-tertiary text-text-supporting hover:bg-background-quaternary'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default TabNavigation;
